export default __webpack_public_path__ + "static/media/Fashion data visualization.71fd4a21.png";